// extracted by mini-css-extract-plugin
export default {"container":"BuisnessParter_container__R6IMN","heroimg":"BuisnessParter_heroimg__1nWBv"};